import src from "IMAGE";
export default { src, width: 406, height: 306, blurWidth: 0, blurHeight: 0};
